import { render, staticRenderFns } from "./EventManagement.vue?vue&type=template&id=5fdb268e&scoped=true&"
import script from "./EventManagement.vue?vue&type=script&lang=js&"
export * from "./EventManagement.vue?vue&type=script&lang=js&"
import style0 from "./EventManagement.vue?vue&type=style&index=0&id=5fdb268e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdb268e",
  null
  
)

export default component.exports